import React, { useCallback, useState } from "react";
import { connect } from "react-redux";

import { Divider } from "@material-ui/core";

import { setItem } from "../../actions";
import { numPathsOptions } from '../../config/simulation';

import { TitleInput, ImageUpload, NumericInput, Select, /*TextItemList, */ TextInput, PackageImport } from '../EditorFormElements'
import { AttentionText } from "../PracticeComponents";
import { EditorTabs } from '../Interface';
import { FormFieldWrapper } from "../Global";
import { SimulationStepper } from "./SimulationStepper";

const UnconnectedSimulationForm = ({given,setItem, ...props}) => {
  const [numPaths,setNumPaths] = useState(given.numPaths || 1);

  const onNumPathsChange = useCallback((name,value) => {
    for (let i = 2; i > (value - 1); i--) {
      setItem('task,paths,' + i, null)
    }
    setNumPaths(value)
  }, [setItem])

  const generalTab = (
    <>
      <PackageImport />
      
      <FormFieldWrapper>

        <TitleInput
          label="Item Title"
          defaultText="Enter item title"
          given={given.title}
        /> 

      </FormFieldWrapper>

      <FormFieldWrapper halfSizeInputs >

        <Select
          label="Number of Paths"
          name='numPaths'
          options={numPathsOptions}
          given={given.numPaths}
          callback={onNumPathsChange}
          help="If changed, you will lose content provided for other paths."
        /> 

        <NumericInput
          label="Duration (minutes)"
          name="minutes"
          min={0}
          max={120}
          given={given.minutes}
        />

      </FormFieldWrapper>

      <FormFieldWrapper>

        <TextInput
          label="Resources URL"
          name="resourcesLink"
          given={given.resourcesLink}
          help="Provide the simulation resource page's published URL from AFPIMS."
        /> 

      </FormFieldWrapper>

      <Divider/>

      <AttentionText given={given.attention} />

    </>
  )

  const stylesTab  =  <>
    <FormFieldWrapper>
      <ImageUpload 
        label="Instruction Background Image" 
        name="bg" 
        tooltip="Upload an image to display as the background of the instructions page. Must be the size 1280 x 998px and not exceed 150KB."
        given={given.bg}
      />
    </FormFieldWrapper>

    <Divider />

    <FormFieldWrapper>
      <ImageUpload 
        label="Question Background Image" 
        name="taskBg" 
        tooltip="Upload one image to display as the background of all question pages. Must be the size 1280 × 499px and not exceed 150KB."
        given={given.taskBg}
      />
    </FormFieldWrapper>
  </>


  const contentTab = (
    <SimulationStepper 
      given={given}
      numPaths={numPaths} 
    />
  )
   
  return (
    <EditorTabs
      general={generalTab}
      styles={stylesTab}
      content={contentTab}
    />
  );
}

export const SimulationForm = connect(null, ({setItem}))(UnconnectedSimulationForm);